import Swal from 'sweetalert2';

export function confirmDelete({
  title = 'Confirm Delete',
  text = 'Are you sure you want to delete this item?',
  icon = 'warning',
  confirmButtonText = 'Yes, delete it!',
  cancelButtonText = 'Cancel',
  confirmButtonColor = '#d33',
  cancelButtonColor = '#3085d6'
} = {}) {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText
  });
} 